import * as React from 'react';
import { cn } from '../utils/cn';

export interface CardProps {
  title?: React.ReactNode;
  extra?: React.ReactNode;
  size?: 'default' | 'small';
  type?: 'default' | 'inner';
  bordered?: boolean;
  hoverable?: boolean;
  cover?: React.ReactNode;
  bodyStyle?: React.CSSProperties;
  headStyle?: React.CSSProperties;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  id?: string;
  children?: React.ReactNode;
}

export function Card({
  title,
  extra,
  size = 'default',
  type = 'default',
  bordered = true,
  hoverable = false,
  cover,
  bodyStyle,
  headStyle,
  className,
  style,
  onClick,
  id,
  children,
}: CardProps) {
  const isInner = type === 'inner';

  return (
    <div
      id={id}
      className={cn(
        'bg-white font-body rounded-sm overflow-hidden',
        bordered && 'border border-border',
        !isInner && 'shadow-sm',
        hoverable && 'hover:shadow-md hover:border-primary/20 transition-shadow duration-fast cursor-pointer',
        onClick && !hoverable && 'cursor-pointer',
        isInner && 'bg-surface-raised',
        className
      )}
      style={style}
      onClick={onClick}
    >
      {cover && (
        <div className="overflow-hidden">{cover}</div>
      )}

      {(title || extra) && (
        <div
          className={cn(
            'flex items-center justify-between border-b border-border',
            size === 'small' ? 'px-3 py-2' : 'px-4 py-3'
          )}
          style={headStyle}
        >
          {title && (
            <div className={cn(
              'font-medium text-foreground flex-1',
              size === 'small' ? 'text-sm' : 'text-base'
            )}>
              {title}
            </div>
          )}
          {extra && (
            <div className="text-sm text-muted shrink-0 ml-3">{extra}</div>
          )}
        </div>
      )}

      <div
        className={cn(size === 'small' ? 'p-3' : 'p-4')}
        style={bodyStyle}
      >
        {children}
      </div>
    </div>
  );
}
